<app-page-body
  [class]="'tw-pt-2'"
  *ngIf="baseSendSmsConfig?.isShowPageHeader && !pageConfig.isVisibleHelpPage"
>
  <!------------------------------- header ------------------------------>
  <app-page-header
    [title]="baseSendSmsConfig?.title"
    [showAddBtn]="false"
    [showAuditBtn]="false"
    [showRefreshBtn]="false"
    (onShowHelp)="pageConfig.isVisibleHelpPage = $event"
  >
    <div class="card-toolbar" after-btns>
      @if (!formPageConfig?.isEditMode) {

      <!-- open sendQueue -->
      <page-header-btn
        name="occasionScheduledMessage"
        icon="mdi-calendar-check"
        title="pages.occasionScheduledMessage.title"
        btnColor="btn-light-info"
        iconSize="mdi-22px"
      ></page-header-btn>
      }

      <!-- back btn -->
      <a
        *ngIf="formPageConfig.isEditMode"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise sm:tw-mb-0 tw-mb-2"
        mat-ripple
        [matTooltip]="'common.back' | translate"
        (click)="onClose()"
      >
        <i class="mdi mdi-arrow-left mdi-20px p-0"></i>
      </a>
    </div>
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <form [id]="formId" [formGroup]="form" autocomplete="off">
      <div
        class="tw-grid xl:tw-grid-cols-4 md:tw-grid-cols-2 tw-grid-cols-1 tw-gap-2"
      >
        <!-- part 1 messageInformation -->
        <section class="xl:tw-col-span-1">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-message-cog tw-ml-2"></i>
              {{ pageVocabs + "legends.messageInformation" | translate }}
            </legend>

            <div class="row">
              <!-- senderNumberId + smsBody -->
              <app-sms-body
                [form]="form"
                smsBodyControlName="smsBody"
                senderNumberControlName="senderNumberId"
                [useType]="baseSendSmsConfig?.useType"
                [senderNumberId]="model.privateNumberId"
                [sendType]="baseSendSmsConfig?.sendType"
                [isEditMode]="formPageConfig.isEditMode"
                [smsBody]="baseSendSmsConfig?.isEdit ? model.smsText : ''"
                [isAddSignature]="
                  !baseSendSmsConfig?.isEdit
                    ? baseSendSmsConfig?.isAddSignature
                    : false
                "
                [isAddHeader]="
                  !baseSendSmsConfig?.isEdit
                    ? baseSendSmsConfig?.isAddHeader
                    : false
                "
                [privateNumberType]="baseSendSmsConfig?.privateNumberType"
                (senderNumberId)="model.privateNumberId = $event"
                (finalSmsBody)="model.smsText = $event"
              >
              </app-sms-body>
            </div>
          </fieldset>
        </section>

        <!-- part 2 receivers -->
        <section
          class="xl:tw-col-span-2"
          *ngIf="baseSendSmsConfig?.isShowReceivers"
        >
          <!-- part 2 phonebook Recipients -->
          <fieldset receivers class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-card-account-phone tw-ml-2"></i>
              {{ pageVocabs + "legends.phonebook" | translate }}
            </legend>

            <div>
              <phonebook-selector
                [isShowInputs]="false"
                [isShowGlobalIndex]="false"
                (recipientsChange)="
                  changePhonebookIds($event); changeFormStatus()
                "
              >
              </phonebook-selector>
            </div>
          </fieldset>
        </section>

        <!-- part 3  messageInformation -->
        <section class="xl:tw-col-span-1">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-calendar-clock tw-ml-2"></i>
              {{ "common.sendDateTimeType" | translate }}
            </legend>

            <div class="tw-flex tw-justify-between tw-flex-col tw-h-full">
              <div class="row">
                <!--howManyDaysSendItBeforeDueDate-->
                <div class="tw-w-full">
                  <form-field
                    type="tel"
                    [hasNumberSeparator]="true"
                    [(value)]="model.howManyDaysSendItBeforeDueDate"
                    [control]="form?.get('howManyDaysSendItBeforeDueDate')"
                    [label]="fields + 'howManyDaysSendItBeforeDueDate'"
                  >
                  </form-field>
                </div>

                <!-- dynamicTemplateId -->
                <div class="tw-w-full">
                  <dynamic-template-select-search
                    [value]="model?.dynamicTemplateId || null"
                    [control]="form?.get('dynamicTemplateId')"
                    (valueChange)="model.dynamicTemplateId = $event"
                  >
                  </dynamic-template-select-search>
                </div>

                <!-- type -->
                <div class="tw-w-full">
                  <custom-select-search
                    label="common.type"
                    [items]="occasionalPostingTypes"
                    [control]="form?.get('type')"
                    optionTitle="title"
                    optionValue="id"
                    [removable]="true"
                    [(value)]="selectedValue"
                  >
                  </custom-select-search>
                </div>

                <!--custom fields-->
                <div
                  class="tw-w-full"
                  *ngIf="selectedValue == SendOccasionType.CustomField"
                >
                  <organization-custom-field-select-search
                    type="nameEn"
                    [customFieldType]="CustomFieldTypes.Datetime"
                    [control]="form?.get('customField')"
                    [value]="model.phonebookCustomFieldNameEn"
                    (itemChange)="setCustomField($event)"
                    (onError)="onClose()"
                  >
                  </organization-custom-field-select-search>
                </div>

                <!-- calendar field -->

                <!-- calender Occasion -->
                <div class="tw-w-full" *ngIf="selectedValue">
                  <form-field
                    *ngIf="selectedValue == SendOccasionType.CalendarEvent"
                    class="tw-w-full"
                    [(value)]="calenderEventTitle"
                    [control]="form?.get('calenderOccasion')"
                    (click)="onShowEventsModal('calendarEvent', $event)"
                    [label]="pageVocabs + 'fields.calendarEvents' | translate"
                    [isReadOnly]="true"
                  >
                    <div suffix-content>
                      <i
                        class="mdi mdi-calendar-month mdi-23px menu-btn tw-text-gray-400 dark:tw-text-gray-300 tw-cursor-pointer tw-mr-[2px] ltr:tw-ml-[2px]"
                        [matTooltip]="'common.calendar' | translate"
                      ></i>
                      <mat-icon
                        class="bg-icon tw-absolute tw-left-[16px] tw-bottom-[27%] tw-text-gray-400 tw-pt-2 tw-px-2 tw-cursor-pointer"
                        *ngIf="calenderEventTitle"
                        (click)="occasionInputClear('fieldText')"
                        [matTooltip]="'common.delete' | translate"
                      >
                        delete_forever
                      </mat-icon>
                    </div>
                  </form-field>

                  <!-- calender Organization Occasion -->
                  <form-field
                    *ngIf="
                      selectedValue ==
                      SendOccasionType.CalenderOrganizationEvent
                    "
                    (click)="
                      onShowEventsModal('calendarOrganizationEvent', $event)
                    "
                    class="tw-w-full"
                    [control]="form?.get('calenderOrganizationOccasion')"
                    [isReadOnly]="true"
                    [label]="
                      pageVocabs + 'fields.calenderOrganizationEvents'
                        | translate
                    "
                    [(value)]="calenderOrganizationEventTitle"
                  >
                    <div suffix-content>
                      <i
                        [matTooltip]="'common.calendar' | translate"
                        class="mdi mdi-calendar-month mdi-23px menu-btn dark:tw-text-gray-300 tw-text-gray-400 tw-cursor-pointer"
                      ></i>
                      <mat-icon
                        class="bg-icon tw-absolute tw-left-[16px] tw-bottom-[27%] text-gray tw-px-2 tw-pt-2 tw-cursor-pointer"
                        *ngIf="calenderOrganizationEventTitle"
                        (click)="occasionInputClear('fieldText')"
                        [matTooltip]="'common.delete' | translate"
                      >
                        delete_forever
                      </mat-icon>
                    </div>
                  </form-field>
                </div>

                <!-- date time picker -->
                <div class="tw-w-full">
                  <timepicker
                    label="common.sendHour"
                    [value]="model.sendDateTime"
                    (value)="model.sendDateTime = $event"
                    [control]="form?.get('sendTime')"
                    [confirmBtnClass]="'btn' | themeColor"
                  >
                  </timepicker>
                </div>

                <!--isActive-->
                <div class="tw-w-full m-auto tw-flex tw-flex-col tw-pt-3">
                  <mat-slide-toggle
                    formControlName="isActive"
                    [(ngModel)]="model.isActive"
                  >
                    {{ "common.isActive" | translate }}
                  </mat-slide-toggle>

                  <div class="tw-mt-2">
                    <mat-slide-toggle
                      formControlName="toConsiderYear"
                      [(ngModel)]="model.toConsiderYear"
                    >
                      {{
                        pageVocabs + "fields.toConsiderYear"
                          | translate
                          | translate
                      }}
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>

              <!-- submit btn -->
              <button
                type="submit"
                mat-ripple
                class="btn tw-py-2 tw-mb-1 tw-mt-6 tw-w-full button-shadow btn-hover-rise"
                (click)="onSubmit()"
                [themeColor]="'btn-gradient'"
                [disabled]="loading"
              >
                <ng-container *ngIf="!loading">
                  <!-- create mode -->
                  <ng-container *ngIf="!formPageConfig?.isEditMode">
                    {{ "common.sendSms" | translate }}
                    <i class="fas fa-paper-plane tw-text-2xl"></i>
                  </ng-container>

                  <!-- edit mode -->
                  <ng-container *ngIf="formPageConfig?.isEditMode">
                    {{ "common.editSendSms" | translate }}
                    <i class="fas fa-pen tw-text-2xl"></i>
                  </ng-container>
                </ng-container>

                <!-- loading -->
                <ng-container *ngIf="loading">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </ng-container>
              </button>
            </div>
          </fieldset>
        </section>
      </div>
    </form>

    <!-- sendLoading -->
    <app-special-loading *ngIf="sendLoading" special-loading type="sending">
    </app-special-loading>
  </div>
</app-page-body>
<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="'SendOccasionSms'"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
